import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import mapIcon from '../assets/android/ui/p4r_map_my_location.svg';

export default function LocationPrompt({ show, onAllow, onDeny, blocked = false }) {
  return (
    <Modal show={show} onHide={onDeny} centered dialogClassName="p4r-location-dialog" contentClassName="p4r-location-sheet">
      <div className="p4r-sheet-handle" aria-hidden="true" />
      <Modal.Body>
        <div className="p4r-location-icon"><img src={mapIcon} alt="" /></div>
        <h2>{blocked ? 'Location is blocked' : 'Use your location?'}</h2>
        <p>{blocked
          ? 'Allow location for this site in your browser settings, then try again. You can still browse Pool 4 Real places without it.'
          : 'Center the map on you and improve nearby players, rooms, and tournament discovery. You can turn this off later.'}</p>
        <div className="p4r-location-actions">
          <Button variant="outline-light" onClick={onDeny}>Not now</Button>
          <Button onClick={onAllow}>{blocked ? 'Try again' : 'Allow location'}</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
